import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router";
import JobView from './JobView';

@inject('commonStore','userInfoStore')
@observer
class JobContainer extends Component {

  UNSAFE_componentWillMount() {
    this.props.userInfoStore.setCommonStoreInfo(this.props.commonStore);
    this.props.userInfoStore.onClear();
    this.props.userInfoStore.disJobList('', '', '');
  }

  render() {
    const { sessionLoginInfo } = this.props.commonStore;
    return (
      <Fragment>
        <JobView
          ceType={(sessionLoginInfo !== null && sessionLoginInfo.ceType !== undefined &&  sessionLoginInfo.ceType !== null) 
            ? sessionLoginInfo.ceType : "" }
        />
      </Fragment>
    );
  }

}

export default withRouter(JobContainer);
